export function buildCalendarWeeks({ year, month, bookings, unavailable }) {
  const firstDay = new Date(year, month - 1, 1);
  const firstWeekday = firstDay.getDay();
  const daysInMonth = new Date(year, month, 0).getDate();

  const fullDay = (unavailable && unavailable.fullDay) || [];
  const weeks = [];
  let week = [];

  for (let i = 0; i < firstWeekday; i++) week.push(null);

  for (let d = 1; d <= daysInMonth; d++) {
    const dateStr = `${year}-${String(month).padStart(2, "0")}-${String(
      d
    ).padStart(2, "0")}`;
    const hasBookings = bookings.some((b) => b.date === dateStr);
    const isFullDayBlocked =
      Array.isArray(fullDay) && fullDay.includes(dateStr);

    week.push({ day: d, dateStr, hasBookings, isFullDayBlocked });

    if (week.length === 7) {
      weeks.push(week);
      week = [];
    }
  }

  if (week.length) {
    while (week.length < 7) week.push(null);
    weeks.push(week);
  }

  return weeks;
}
